import { getReduxStore } from 'src/init/store';
import { performLogout } from 'src/views/public/login/actions';

export const forceLogoutUser = (isExpired = false) => {
  const store = getReduxStore();
  if (store) {
    store.dispatch(performLogout(isExpired));
  }
};
